import React from 'react';
import { buildClassName } from '../../../utils';
import type { CustomNavigationButton } from '../../../types';
import type { NavigationStyleOverrides } from '../../../types/base';
import { NavigationButtonBase } from './NavigationButtonBase';
import { DropdownArrow } from './DropdownArrow';
import styles from '../DesktopNavigation.module.scss';

/**
 * @internal
 * This component is an internal implementation detail of the navigation module.
 * Do not import or use this component directly from outside the navigation module.
 * Use the public API from '@core/ui/navigation' instead.
 */

interface NavigationButtonCustomProps {
  item: CustomNavigationButton;
  isExpanded: boolean;
  onMouseEnter: () => void;
  onClick: () => void;
  showChevron?: boolean;
  styleOverrides?: NavigationStyleOverrides;
}

export const NavigationButtonCustom = ({ 
  item, 
  isExpanded, 
  onMouseEnter,
  onClick,
  showChevron = true,
  styleOverrides = {}, 
}: NavigationButtonCustomProps) => (
  <div 
    className={buildClassName(styles.buttonContainer, styleOverrides.navButton)}
    onMouseEnter={onMouseEnter}
  >
    <NavigationButtonBase
      className={styleOverrides.navButton}
      isExpanded={isExpanded}
      aria-label={item.label}
      onClick={onClick}
    >
      {item.leftSection}
      {item.customTrigger || item.label}
      {item.rightSection}
      {showChevron && (
        <DropdownArrow isExpanded={isExpanded} />
      )}
    </NavigationButtonBase>
    {isExpanded && (
      <div className={buildClassName(styles.dropdown, styleOverrides.dropdown)}>
        {item.customContent}
      </div>
    )}
  </div>
); 